import { z } from 'zod'

export const intervalOptions = ['1day', '7day', '30day'] as const
export const interval = z.enum(intervalOptions)
export type Interval = z.infer<typeof interval>

const secondsInDay = 86_400
export const intervalInSeconds = {
  '1day': secondsInDay,
  '7day': secondsInDay * 7,
  '30day': secondsInDay * 30,
} satisfies Record<Interval, number>
